module.exports = __webpack_public_path__ + "static/media/arrow-right-blue.3d453cd6.svg";